import { Tabs, TabsProps } from 'antd';
import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { TEXT_BUTTON_HEADER_LIST } from '../../../config/config';
import { PermissionCupons } from '../../../permissions/PermissionCupons';
import categoryStore from '../../../stores/categoryStore';
import cupomStore from '../../../stores/cupomStore';
import unsavedStore from '../../../stores/unsavedStore';
import { convertString, convertToDayjs, formattedDates, updateOrAddRestriction } from '../../../utils/functions';
import { findPriceRestriction, findRestrictionProduct } from '../../../utils/functionsRestrictions';
import BreadCrumbComponent from '../../atoms/BreadCrumbComponent';
import ActionButton from '../../atoms/ButtonComponent';
import NotPermissionComponent from '../../atoms/NotPermissionComponent';
import ContentBox from '../../molecules/ContentBox';
import LoadingComponent from '../../molecules/LoadingComponent';
import Permission from '../../molecules/Permission';
import { useAuth } from '../../protected/ProviderAuth';
import ApplicationType from './components/ApplicatinType';
import CustomerAddPromotion from './components/CustomerAddPromotion';
import InformationComponent from './components/InformationComponent';
import TableZipCodeRestriction from './components/TableZipCodeRestriction';


interface FormValues {
    "@class": string;
    active: { value: string; label: string }
    type: { value: string; label: string };
    productsPercentageDiscount: string;
    excludeZipCode: { value: string; label: string };
    excludeProductCategory: { value: string; label: string };
    name: string;
    productsAbsoluteDiscount: string;
    date: any;
    aplicationType: { value: string; label: string };
    excludeClient: { value: string; label: string };
    maxUses: string;
    minPrice: string;
    maxPrice: string;
    priceRestrictionExcludes: { value: string; label: string };
    yesOrNoMaxUses: { value: string; label: string };
}

const breadCrumb = [
    {
        title: <Link to="/dashboard">Dashboard</Link>,
    },
    {
        title: <Link to="/cupons">Listagem de Cupons</Link>,
    },
    {
        title: <p>Cadastro de Cupom</p>,
    },
]

const CreateCupom: React.FC = observer(() => {
    const { uuid } = useParams<{ uuid: string }>();
    const navigate = useNavigate();
    const [aplicationType, setAplicationType] = useState<any>();
    const { cupomProps, loading, zipCodeRestrictionList, customerRestrictionItem, categoriesOrProdutcts, dateRestrictionList, customerList, categoryList, zipCodeRestriction, productList } = cupomStore;
    const { hasPermission } = useAuth();

    useEffect(() => {
        getInformation();
        return () => {
            cupomStore.reset();
        };
    }, []);

    const getInformation = async () => {
        if (uuid && hasPermission(PermissionCupons.GET_UUID)) {
            const response = await cupomStore.getCupomByUuid(uuid);
            setAplicationType({ value: findRestrictionProduct(response?.restrictions) || '', label: '' })
        }

        await categoryStore.getList();
    }


    const findfirstPurchase = (restriction: any) => {
        const findRestriction = restriction?.find((item: any) => item['@class'] === 'br.com.stoom.kernel.model.persistence.restriction.FirstPurchaseRestriction');
        return findRestriction?.excludes === true ? 'true' : 'false'
    }

    //@ts-ignore
    const initialValues: FormValues = {
        name: cupomProps?.name || '',
        active: cupomProps?.active || '',
        type: { value: cupomProps?.discount?.productsPercentageDiscount > 0 ? 'Desconto Percentual X' : 'Desconto Absoluto X', label: '' },
        productsAbsoluteDiscount: (cupomProps && cupomProps?.discount && cupomProps?.discount?.productsAbsoluteDiscount) || '',
        productsPercentageDiscount: (cupomProps && cupomProps?.discount && cupomProps?.discount?.productsPercentageDiscount * 100) || '',
        date: cupomProps ? [convertToDayjs(dateRestrictionList?.minDate), convertToDayjs(dateRestrictionList?.maxDate)] : '',
        excludeZipCode: { value: zipCodeRestriction?.excludes === true ? 'true' : 'false', label: '' },
        excludeProductCategory: { value: categoriesOrProdutcts?.excludes === true ? 'true' : 'false', label: '' },
        aplicationType: { value: findRestrictionProduct(cupomProps?.restrictions) || '', label: '' },
        excludeClient: { value: customerRestrictionItem?.excludes === true ? 'true' : 'false', label: '' },
        maxUses: cupomProps?.maxUses || '',
        minPrice: findPriceRestriction(cupomProps?.restrictions, 'minPrice') || '',
        maxPrice: findPriceRestriction(cupomProps?.restrictions, 'maxPrice') || '',
        priceRestrictionExcludes: { value: findPriceRestriction(cupomProps?.restrictions, 'exclude'), label: '' },
        yesOrNoMaxUses: { value: findfirstPurchase(cupomProps?.restrictions), label: '' },
    };


    const handleSubmit = async (values: FormValues) => {
        let response;
        const formattedDate = formattedDates(values.date, 'YYYY-MM-DD');

        // Inicializa as restrições
        const restrictions = [...(cupomProps?.restrictions || [])];

        //Atualiza ou adiciona a restrição de Data
        updateOrAddRestriction(restrictions, {
            "@class": "br.com.stoom.kernel.model.persistence.restriction.DateRestriction",
            minDate: `${formattedDate[0]}T00:00:00.000`,
            maxDate: `${formattedDate[1]}T23:59:59.000`
        });

        //Atualiza ou adiciona a restrição de CEP
        if (zipCodeRestrictionList?.length > 0) {
            updateOrAddRestriction(restrictions, {
                "@class": "br.com.stoom.kernel.model.persistence.restriction.ZipCodeRestriction",
                excludes: values.excludeZipCode?.value === 'true',
                zipCodeRangeRestrictions: zipCodeRestrictionList
            });
        }

        //Atualiza ou adiciona a restrição de Categoria de Produto
        if (categoryList?.length > 0 || productList?.length > 0) {
            updateOrAddRestriction(restrictions, {
                "@class": "br.com.stoom.kernel.model.persistence.restriction.ProductCategoryRestriction",
                excludes: values.excludeProductCategory?.value === 'true',
                categories: aplicationType.value === 'CATEGORIA' ? categoryList.map((uuid: string) => ({ uuid })) : [],
                products: aplicationType.value === 'PRODUTO' ? productList : []
            });
        }

        //Atualiza ou adiciona a restrição de Cliente
        if (customerList && customerList?.length > 0) {
            updateOrAddRestriction(restrictions, {
                "@class": "br.com.stoom.kernel.model.persistence.restriction.CustomerRestriction",
                excludes: values.excludeClient?.value === 'true',
                documents: customerList
            });
        }

        if (values?.yesOrNoMaxUses?.value === 'true') {
            updateOrAddRestriction(restrictions, {
                "@class": "br.com.stoom.kernel.model.persistence.restriction.FirstPurchaseRestriction",
                excludes: values.yesOrNoMaxUses?.value,
            });
        } else {
            updateOrAddRestriction(restrictions, {
                "@class": "br.com.stoom.kernel.model.persistence.restriction.FirstPurchaseRestriction",
                excludes: values.yesOrNoMaxUses?.value,
            });
        }

        if (values.priceRestrictionExcludes.value === 'true') {
            updateOrAddRestriction(restrictions, {
                "@class": "br.com.stoom.kernel.model.persistence.restriction.PriceRestriction",
                excludes: values.priceRestrictionExcludes?.value,
                maxPrice: values.maxPrice,
                minPrice: values.minPrice,
            });
        } else {
            updateOrAddRestriction(restrictions, {
                "@class": "br.com.stoom.kernel.model.persistence.restriction.PriceRestriction",
                excludes: values.priceRestrictionExcludes?.value,
                maxPrice: undefined,
                minPrice: undefined,
            });
        }

        const updateValues = {
            ...cupomProps,
            active: values.active || false,
            deleted: false,
            name: values.name,
            maxUses: values.maxUses,
            discount: {
                "@class": "br.com.stoom.kernel.model.persistence.Discount",
                productsAbsoluteDiscount: values?.type?.value === 'Desconto Absoluto X' ? Number(values?.productsAbsoluteDiscount) : 0,
                productsPercentageDiscount: values?.type?.value === 'Desconto Percentual X' ? (Number(values?.productsPercentageDiscount) / 100) : 0,
                shippingAbsoluteDiscount: 0,
                shippingPercentageDiscount: 0,
                buyXPayY: {
                    x: 0,
                    y: 0,
                    cumulative: true,
                    uuid: cupomProps && cupomProps.discounts && cupomProps?.discounts[0]?.buyXPayY?.uuid
                },
                uuid: cupomProps && cupomProps.discounts && cupomProps?.discounts[0]?.uuid
            },
            restrictions: restrictions || [],
            vouchers: [
                {
                    identifier: convertString(values.name)
                }
            ],
        };

        if (uuid) {
            response = await cupomStore.editCupom(updateValues, uuid);
        } else {
            response = await cupomStore.createCupom(updateValues);
        }

        if (!response.error) listRouter();
    };

    const listRouter = () => {
        navigate(`/cupons`);
    }

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Informação Geral',
            children: <InformationComponent />,
        },
        {
            key: '3',
            label: 'Faixa do CEP ',
            children: <TableZipCodeRestriction />,
        },
        {
            key: '4',
            label: 'Aplicação ',
            //@ts-ignore
            children: <ApplicationType setAplicationType={setAplicationType} aplicationType={aplicationType} />,
        },
        {
            key: '5',
            label: 'Cliente ',
            //@ts-ignore
            children: <CustomerAddPromotion />,
        },
    ];


    return (
        <>
            <BreadCrumbComponent breadCrumbList={breadCrumb} permission={PermissionCupons.GET} textButton={TEXT_BUTTON_HEADER_LIST} onClick={() => listRouter()} />

            {loading &&
                <ContentBox className="mb-4 p-6" title="Cadastro de Cupom" description='Tela para cadastro de Cupom'>
                    <LoadingComponent />
                </ContentBox>
            }

            {!loading &&
                <Permission
                    permissionKeys={[PermissionCupons.POST, PermissionCupons.PUT, PermissionCupons.GET_UUID]}
                    fallback={NotPermissionComponent()}
                >
                    <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                    // validationSchema={validationSchema}
                    >
                        {({ dirty }) => {
                            useEffect(() => {
                                unsavedStore.updateUnsavedChanges(dirty);
                            }, [dirty]);

                            return (
                                <>
                                    <Form>
                                        <Tabs className="mb-0" type="card" defaultActiveKey="1" items={items} />

                                        <div className="flex justify-end">
                                            <Permission permissionKeys={[PermissionCupons.PUT, PermissionCupons.POST]} buttonType>
                                                <ActionButton htmlType="submit" actionType="primary">{uuid ? "Atualizar" : "Cadastrar"}</ActionButton>
                                            </Permission>
                                        </div>
                                    </Form>
                                </>
                            );
                        }}
                    </Formik >
                </Permission>
            }
        </>
    );
});

export default CreateCupom;

